import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type SummaryTopic = {
  label: string;
  emoji?: string;
};

export type Summary = WithLegacy<{
  title: string | null;
  text: string | null;
  topics: SummaryTopic[] | null;
  subjectEmoji: string | null;
  language: string | null;
  hasExtractableItems: boolean | null;
  hasRecipes: boolean | null;
  llmProvider: string | null;
  llmModel: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  contentSource: import('./content-source.ts').ContentSource | null;
  [Type]: 'summaries';
}>;

export const SummarySchema = withDefaults({
  type: 'summaries',
  fields: [
    { name: 'title', kind: 'attribute', type: 'string' },
    { name: 'text', kind: 'attribute', type: 'string' },
    { name: 'topics', kind: 'attribute', type: 'object' },
    { name: 'subjectEmoji', kind: 'attribute', type: 'string' },
    { name: 'language', kind: 'attribute', type: 'string' },
    { name: 'hasExtractableItems', kind: 'attribute', type: 'boolean' },
    { name: 'hasRecipes', kind: 'attribute', type: 'boolean' },
    { name: 'llmProvider', kind: 'attribute', type: 'string' },
    { name: 'llmModel', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
    {
      name: 'contentSource',
      kind: 'belongsTo',
      type: 'content-sources',
      options: { async: true, inverse: null },
    },
  ],
});
